<template>
  <div :class="['projectDataboard', !isPc && 'mobile']" id="projectDataboard" :style="{'height':contHeight+'px'}">
    <div class="row_top">
      <el-date-picker
        v-model="defaultDate"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        range-separator="至"
        :picker-options="datePickerOption"
        :editable="false"
        :clearable="false"
        :popper-class="isPc ? '' : 'custom-date-picker'"
        :size="isPc ? '' : 'small'"
        class="date-picker"
        @change="changeDate"
        @focus="pickerDefaultDate = ''"
      />
      <el-row type="flex" class="mobile-cnotainer">
        <el-row type="flex" align="middle" class="filter-item">
          <p class="label">当前对比日期</p>
          <el-date-picker
            v-model="compareDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="至"
            :picker-options="compareDatePickerOption"
            :editable="false"
            :clearable="false"
            :popper-class="isPc ? '' : 'custom-date-picker'"
            :size="isPc ? '' : 'small'"
            class="date-picker"
            @change="changeCompareDate"
            @focus="pickerCompareDate = ''"
          />
        </el-row>
        <el-button :loading="loading" type="primary" icon="el-icon-refresh-right" class="refresh-btn" :size="isPc ? '' : 'small'" @click="init">刷新</el-button>
      </el-row>
    </div>
    <!-- 集团总数居 -->
    <div v-if="isPc" class="row cont_1">
      <el-row type="flex" align="middle" class="title">
        <i class="jituan_icon"></i>
        集团总数据
        <el-tooltip effect="dark" placement="top">
          <p slot="content">当神啦考研存在“定金专项班（定金班）”订单时，会<br/>导致基础班业绩和VIP的业绩之和与总业绩有偏差，订<br/>单数同理</p>
          <i class="icon-question" />
        </el-tooltip>
      </el-row>
      <div class="cont_data">
        <el-row>
          <el-col :span="4">
            <div class="title_h blue">总业绩（元）</div>
            <div class="value blue">{{ topInfo.payAmt ? topInfo.payAmt.toLocaleString() : 0 }}</div>
          </el-col>
          <el-col :span="4">
            <div class="title_h">基础班业绩（元）</div>
            <div class="value">
              {{ topInfo.baseAmt ? topInfo.baseAmt.toLocaleString() : 0 }}<span class="rate">({{topInfo.baseAmtRate || 0}}%)</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="title_h">VIP业绩（元）</div>
            <div class="value">{{ topInfo.vipAmt ? topInfo.vipAmt.toLocaleString() : 0 }}<span class="rate">({{topInfo.vipAmtRate || 0}}%)</span></div>
          </el-col>
          <el-col :span="2" class="line_cont">
            <div class="line"></div>
          </el-col>
          <el-col :span="3">
            <div class="title_h blue">总订单数（条）</div>
            <div class="value blue">{{ topInfo.orderNum ? topInfo.orderNum.toLocaleString() : 0 }}</div>
          </el-col>
          <el-col :span="3">
            <div class="title_h">基础班订单数（条）</div>
            <div class="value">{{ topInfo.baseNum ? topInfo.baseNum.toLocaleString() : 0 }}<span class="rate">({{topInfo.baseNumRate || 0}}%)</span></div>
          </el-col>
          <el-col :span="3">
            <div class="title_h">VIP班订单数（条）</div>
            <div class="value">{{ topInfo.vipNum ? topInfo.vipNum.toLocaleString() : 0 }}<span class="rate">({{topInfo.vipNumRate || 0}}%)</span></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row class="bg-row">
              <el-col :span="8">
                <div class="title_sub">
                  同期对比（元）
                  <el-tooltip effect="dark" placement="top">
                    <p slot="content">展示数据为顶部右侧所选日期的业绩，与左<br/>侧所选日期业绩对比。</p>
                    <i class="icon-question" />
                  </el-tooltip>
                </div>
                <template v-if="samePeriod.payAmt || samePeriod.payAmt === 0">
                  <div class="value_sub">{{ samePeriod.payAmt.toLocaleString() }}<span :class="['index', samePeriod['isDown_amtRate'] ? 'down' : 'up']">{{samePeriod.amtRate || 0}}%</span></div>
                </template>
                <span v-else class="value_sub tips">暂无同期数据对比</span>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">基础班业绩（元）</div>
                <div class="value_sub">{{ samePeriod.baseAmt ? samePeriod.baseAmt.toLocaleString() : 0 }}<span :class="['index', samePeriod['isDown_baseAmtRate'] ? 'down' : 'up']">{{samePeriod.baseAmtRate || 0}}%</span></div>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">VIP业绩（元）</div>
                <div class="value_sub">{{ samePeriod.vipAmt ? samePeriod.vipAmt.toLocaleString() : 0 }}<span :class="['index', samePeriod['isDown_vipAmtRate'] ? 'down' : 'up']">{{samePeriod.vipAmtRate || 0}}%</span></div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2" class="line_cont">
            <div class="line"></div>
          </el-col>
          <el-col :span="10">
            <el-row class="bg-row">
              <el-col :span="8">
                <div class="title_sub">同期对比（条）</div>
                <template v-if="samePeriod.orderNum || samePeriod.orderNum === 0">
                  <div class="value_sub">{{ samePeriod.orderNum.toLocaleString() }}<span :class="['index', samePeriod['isDown_numRate'] ? 'down' : 'up']">{{samePeriod.numRate || 0 }}%</span></div>
                </template>
                <span v-else class="value_sub tips">暂无同期数据对比</span>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">基础班订单数（条）</div>
                <div class="value_sub">{{ samePeriod.baseNum ? samePeriod.baseNum.toLocaleString() : 0 }}<span :class="['index', samePeriod['isDown_baseNumRate'] ? 'down' : 'up']">{{samePeriod.baseNumRate || 0}}%</span></div>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">VIP班订单数（条）</div>
                <div class="value_sub">{{ samePeriod.vipNum ? samePeriod.vipNum.toLocaleString() : 0 }}<span :class="['index', samePeriod['isDown_vipNumRate'] ? 'down' : 'up']">{{samePeriod.vipNumRate || 0}}%</span></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row class="bg-row">
              <el-col :span="8">
                <div class="title_sub">
                  月累计（元）
                  <el-tooltip effect="dark" placement="top">
                    <p slot="content">当顶部左侧日期选择为同一自然月时，则展示<br/>上个月整月的业绩数据，进行业绩对比。</p>
                    <i class="icon-question" />
                  </el-tooltip>
                </div>
                <div v-if="isSameMonth" class="value_sub">{{ cumulative.payAmt ? cumulative.payAmt.toLocaleString() : 0 }}<span :class="['index', cumulative['isDown_amtRate'] ? 'down' : 'up']">{{cumulative.amtRate || 0}}%</span></div>
                <span v-else class="value_sub tips">暂不支持跨月数据对比</span>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">基础班业绩（元）</div>
                <div v-if="isSameMonth" class="value_sub">{{ cumulative.baseAmt ? cumulative.baseAmt.toLocaleString() : 0 }}<span :class="['index', cumulative['isDown_baseAmtRate'] ? 'down' : 'up']">{{cumulative.baseAmtRate || 0}}%</span></div>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">VIP业绩（元）</div>
                <div v-if="isSameMonth" class="value_sub">{{ cumulative.vipAmt ? cumulative.vipAmt.toLocaleString() : 0 }}<span :class="['index', cumulative['isDown_vipAmtRate'] ? 'down' : 'up']">{{cumulative.vipAmtRate || 0}}%</span></div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2" class="line_cont">
            <div class="line"></div>
          </el-col>
          <el-col :span="10">
            <el-row class="bg-row">
              <el-col :span="8">
                <div class="title_sub">月累计（条）</div>
                <div v-if="isSameMonth" class="value_sub">{{ cumulative.orderNum ? cumulative.orderNum.toLocaleString() : 0 }}<span :class="['index', cumulative['isDown_numRate'] ? 'down' : 'up']">{{cumulative.numRate || 0 }}%</span></div>
                <span v-else class="value_sub tips">暂不支持跨月数据对比</span>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">基础班订单数（条）</div>
                <div v-if="isSameMonth" class="value_sub">{{ cumulative.baseNum ? cumulative.baseNum.toLocaleString() : 0 }}<span :class="['index', cumulative['isDown_baseNumRate'] ? 'down' : 'up']">{{cumulative.baseNumRate || 0}}%</span></div>
              </el-col>
              <el-col :span="8">
                <div class="title_sub">VIP班订单数（条）</div>
                <div v-if="isSameMonth" class="value_sub">{{ cumulative.vipNum ? cumulative.vipNum.toLocaleString() : 0 }}<span :class="['index', cumulative['isDown_vipNumRate'] ? 'down' : 'up']">{{cumulative.vipNumRate || 0}}%</span></div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-else class="total-plane-mobile">
      <el-row type="flex" align="middle" class="plane-title">
        <i class="jituan_icon" />
        <p>集团总数据</p>
        <el-tooltip effect="dark" placement="top">
          <p slot="content">当神啦考研存在“定金专项班（定金班）”订单时，会<br/>导致基础班业绩和VIP的业绩之和与总业绩有偏差，订<br/>单数同理</p>
          <i class="icon-question" />
        </el-tooltip>
      </el-row>
      <div class="data-module">
        <div class="data-label blue">总业绩 (元)</div>
        <div class="data-value num blue">{{ topInfo.payAmt ? topInfo.payAmt.toLocaleString() : 0 }}</div>
        <el-row class="compare-module">
          <el-col :span="12">
            <p class="c-name">同期对比（元）</p>
            <p v-if="samePeriod.payAmt || samePeriod.payAmt === 0" class="i-value">
              {{ samePeriod.payAmt.toLocaleString() }}
              <span :class="['i-index', samePeriod['isDown_amtRate'] ? 'down' : 'up']">{{samePeriod.amtRate || 0}}%</span>
            </p>
            <p v-else class="i-value tips">暂无同期数据对比</p>
          </el-col>
          <el-col :span="12">
            <p class="c-name">月累计（元）</p>
            <p v-if="isSameMonth" class="i-value">{{ cumulative.payAmt ? cumulative.payAmt.toLocaleString() : 0 }}<span :class="['i-index', cumulative['isDown_amtRate'] ? 'down' : 'up']">{{cumulative.amtRate || 0}}%</span></p>
            <p v-else class="i-value tips">暂不支持跨月数据对比</p>
          </el-col>
        </el-row>
        <div class="data-label">基础班业绩 (元)</div>
        <div class="data-value num">
          {{ topInfo.baseAmt ? topInfo.baseAmt.toLocaleString() : 0 }}
          <span class="rate">({{topInfo.baseAmtRate || 0}}%)</span>
        </div>
        <el-row class="compare-module">
          <el-col :span="12">
            <p class="c-name">同期对比（元）</p>
            <p class="i-value">{{ samePeriod.baseAmt ? samePeriod.baseAmt.toLocaleString() : 0 }}<span :class="['i-index', samePeriod['isDown_baseAmtRate'] ? 'down' : 'up']">{{samePeriod.baseAmtRate || 0}}%</span></p>
          </el-col>
          <el-col :span="12">
            <p class="c-name">月累计（元）</p>
            <p v-if="isSameMonth" class="i-value">{{ cumulative.baseAmt ? cumulative.baseAmt.toLocaleString() : 0 }}<span :class="['i-index', cumulative['isDown_baseAmtRate'] ? 'down' : 'up']">{{cumulative.baseAmtRate || 0}}%</span></p>
            <p v-else class="i-value tips">暂不支持跨月数据对比</p>
          </el-col>
        </el-row>
        <div class="data-label">VIP业绩 (元)</div>
        <div class="data-value num">
          {{ topInfo.vipAmt ? topInfo.vipAmt.toLocaleString() : 0 }}
          <span class="rate">({{ topInfo.vipAmtRate || 0 }}%)</span>
        </div>
        <el-row class="compare-module">
          <el-col :span="12">
            <p class="c-name">同期对比（元）</p>
            <p class="i-value">{{ samePeriod.vipAmt ? samePeriod.vipAmt.toLocaleString() : 0 }}<span :class="['i-index', samePeriod['isDown_vipAmtRate'] ? 'down' : 'up']">{{samePeriod.vipAmtRate || 0}}%</span></p>
          </el-col>
          <el-col :span="12">
            <p class="c-name">月累计（元）</p>
            <p v-if="isSameMonth" class="i-value">{{ cumulative.vipAmt ? cumulative.vipAmt.toLocaleString() : 0 }}<span :class="['i-index', cumulative['isDown_vipAmtRate'] ? 'down' : 'up']">{{cumulative.vipAmtRate || 0}}%</span></p>
            <p v-else class="i-value tips">暂不支持跨月数据对比</p>
          </el-col>
        </el-row>
      </div>
      <div class="data-module">
        <div class="data-label blue">总订单数 (条)</div>
        <div class="data-value num blue">{{ topInfo.orderNum ? topInfo.orderNum.toLocaleString() : 0 }}</div>
        <el-row class="compare-module">
          <el-col :span="12">
            <p class="c-name">同期对比（条）</p>
            <p v-if="samePeriod.orderNum || samePeriod.orderNum === 0" class="i-value">
              {{ samePeriod.orderNum.toLocaleString() }}
              <span :class="['i-index', samePeriod['isDown_numRate'] ? 'down' : 'up']">{{samePeriod.numRate || 0 }}%</span>
            </p>
            <p v-else class="i-value tips">暂无同期数据对比</p>
          </el-col>
          <el-col :span="12">
            <p class="c-name">月累计（条）</p>
            <p v-if="isSameMonth" class="i-value">{{ cumulative.orderNum ? cumulative.orderNum.toLocaleString() : 0 }}<span :class="['i-index', cumulative['isDown_numRate'] ? 'down' : 'up']">{{cumulative.numRate || 0 }}%</span></p>
            <p v-else class="i-value tips">暂不支持跨月数据对比</p>
          </el-col>
        </el-row>
        <div class="data-label">基础班订单数 (条)</div>
        <div class="data-value num">
          {{ topInfo.baseNum ? topInfo.baseNum.toLocaleString() : 0 }}
          <span class="rate">({{ topInfo.baseNumRate || 0 }}%)</span>
        </div>
        <el-row class="compare-module">
          <el-col :span="12">
            <p class="c-name">同期对比（条）</p>
            <p class="i-value">{{ samePeriod.baseNum ? samePeriod.baseNum.toLocaleString() : 0 }}<span :class="['i-index', samePeriod['isDown_baseNumRate'] ? 'down' : 'up']">{{samePeriod.baseNumRate || 0}}%</span></p>
          </el-col>
          <el-col :span="12">
            <p class="c-name">月累计（条）</p>
            <p v-if="isSameMonth" class="i-value">{{ cumulative.baseNum ? cumulative.baseNum.toLocaleString() : 0 }}<span :class="['i-index', cumulative['isDown_baseNumRate'] ? 'down' : 'up']">{{cumulative.baseNumRate || 0}}%</span></p>
            <p v-else class="i-value tips">暂不支持跨月数据对比</p>
          </el-col>
        </el-row>
        <div class="data-label">VIP班订单数 (条)</div>
        <div class="data-value num">
          {{ topInfo.vipNum ? topInfo.vipNum.toLocaleString() : 0 }}
          <span class="rate">({{ topInfo.vipNumRate || 0 }}%)</span>
        </div>
        <el-row class="compare-module">
          <el-col :span="12">
            <p class="c-name">同期对比（条）</p>
            <p class="i-value">{{ samePeriod.vipNum ? samePeriod.vipNum.toLocaleString() : 0 }}<span :class="['i-index', samePeriod['isDown_vipNumRate'] ? 'down' : 'up']">{{samePeriod.vipNumRate || 0}}%</span></p>
          </el-col>
          <el-col :span="12">
            <p class="c-name">月累计（条）</p>
            <p v-if="isSameMonth" class="i-value">{{ cumulative.vipNum ? cumulative.vipNum.toLocaleString() : 0 }}<span :class="['i-index', cumulative['isDown_vipNumRate'] ? 'down' : 'up']">{{cumulative.vipNumRate || 0}}%</span></p>
            <p v-else class="i-value tips">暂不支持跨月数据对比</p>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 集团总数居end -->
    <!-- 各项目数据 -->
    <div class="row cont_2">
      <div class="top">
        <div class="title"><i class="project_icon"></i>各项目数据</div>
        <div class="tabs_value">
          <!-- <div class="items">
            <div class="items_item" v-for="(item,index) in shiyebuTabs" :key="index" :class="{'active':shiyebuIndex == index}" @click="shiyebuChange(index)">{{item.name}}</div>
          </div> -->
          <div class="items">
            <div class="items_item" v-for="(item,index) in baifenTabs" :key="index" :class="{'active':baifenIndex == index}" @click="baifenChange(index)">{{item.name}}</div>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="list">
        <template v-if="data.length !== 0">
          <div class="item" v-for="(item,index) in data" :key="index">
            <div class="title_span">{{topTitleObj[item.type]}}</div>
            <div class="value_cont head_cont">
              <el-row type="flex" justify="space-between" align="middle">
                <div class="title">总业绩（元）</div>
                <div class="value blue">{{item.payAmt}}</div>
              </el-row>
              <template v-if="item.contrastInfo">
                <el-row type="flex" class="cont-sup-info">
                  <p class="i-name">同期对比（元）</p>
                  <p :class="['i-index', item.contrastInfo.last_month_same_period.amtIndex ? 'down' : 'up']">{{ item.contrastInfo.last_month_same_period.amtRate}}%</p>
                  <p class="i-value">{{ item.contrastInfo.last_month_same_period.payAmt }}</p>
                </el-row>
                <el-row type="flex" class="cont-sup-info">
                  <p class="i-name">月累计（元）</p>
                  <template v-if="isSameMonth">
                    <p :class="['i-index', item.contrastInfo.last_month_cumulative.amtIndex ? 'down' : 'up']">{{ item.contrastInfo.last_month_cumulative.amtRate}}%</p>
                    <p class="i-value">{{ item.contrastInfo.last_month_cumulative.payAmt }}</p>
                  </template>
                  <span v-else class="i-value tips">暂不支持跨月数据对比</span>
                </el-row>
              </template>
              <div class="line"></div>
              <el-row type="flex" justify="space-between" align="middle">
                <div class="title">总订单数（单）</div>
                <div class="value blue">{{item.orderNum}}</div>
              </el-row>
              <el-row type="flex" class="cont-sup-info">
                <p class="i-name">同期对比（单）</p>
                <p :class="['i-index', item.contrastInfo.last_month_same_period.amtIndex ? 'down' : 'up']">{{ item.contrastInfo.last_month_same_period.numRate}}%</p>
                <p class="i-value">{{ item.contrastInfo.last_month_same_period.orderNum }}</p>
              </el-row>
              <el-row type="flex" class="cont-sup-info">
                <p class="i-name">月累计（单）</p>
                <template v-if="isSameMonth">
                  <p :class="['i-index', item.contrastInfo.last_month_cumulative.amtIndex ? 'down' : 'up']">{{ item.contrastInfo.last_month_cumulative.numRate}}%</p>
                  <p class="i-value">{{ item.contrastInfo.last_month_cumulative.orderNum }}</p>
                </template>
                <span v-else class="i-value tips">暂不支持跨月数据对比</span>
              </el-row>
              <div class="line no-mobile"></div>
              <div class="title module-title no-mobile">事业部数据</div>
              <transition name="fade">
                <table class="table" border="0" cellspacing="0" v-if="item.show1">
                  <tr class="th_header" v-if="item.baifenRate">
                    <th>事业部</th>
                    <th>总业绩占比</th>
                    <th>总订单数占比</th>
                  </tr>
                  <tr class="th_header" v-else>
                    <th>事业部</th>
                    <th>总业绩(元)</th>
                    <th>总订单数(条)</th>
                  </tr>
                  <tr v-for="(item_table,index_table) in item.orderList" :key="index_table">
                    <td>{{item_table.companyName}}</td>
                    <td>
                      <transition name="slide">
                        <span v-if="item.baifenRate">{{item_table.amtRate || 0}}%</span>
                      </transition>
                      <transition name="slide">
                        <span v-if="!item.baifenRate">{{ item_table.payAmt ? item_table.payAmt.toLocaleString() : 0 }}</span>
                      </transition>
                    </td>
                    <td>
                      <transition name="slide">
                        <span v-if="item.baifenRate">{{item_table.numRate || 0}}%</span>
                      </transition>
                      <transition name="slide">
                        <span v-if="!item.baifenRate">{{ item_table.orderNum ? item_table.orderNum.toLocaleString() : 0 }}</span>
                      </transition>
                    </td>
                  </tr>
                </table>
              </transition>
              <!-- <div class="change_down" @click="toggleFn(1,item,index)">点击{{item.show1 ? '收起' : '展开'}}<i class="down" :class="{'up':item.show1}"></i></div> -->
            </div>
            <div class="value_cont">
              <div class="title_label">基础班业绩</div>
              <el-row v-if="isPc">
                <el-col :span="15">
                  <div class="title gray">总业绩（元）</div>
                  <div class="value">
                    <span class="value_value">{{item.baseAmt}}</span>
                    <span class="value_baifen">({{item.baseAmtRate}}%)</span>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div class="title gray">总订单数（单）</div>
                  <div class="value">
                    <span class="value_value value_value_2">{{item.baseNum}}</span>
                    <span class="value_baifen">({{item.baseNumRate}}%)</span>
                  </div>
                </el-col>
              </el-row>
              <el-row v-else type="flex" class="mobile-value-cont">
                <div class="mobile-value-cont-item">
                  <p class="title gray">总业绩（元）</p>
                  <p class="value">{{item.baseAmt}}</p>
                  <p class="value_baifen">({{item.baseAmtRate}}%)</p>
                </div>
                <div class="mobile-value-cont-item">
                  <p class="title gray">总订单数（单）</p>
                  <p class="value">{{item.baseNum}}</p>
                  <p class="value_baifen">({{item.baseNumRate}}%)</p>
                </div>
              </el-row>
              <div class="line"></div>
              <div class="title module-title">事业部数据</div>
              <transition name="fade">
                <table class="table" border="0" cellspacing="0" v-if="item.show2">
                  <tr class="th_header" v-if="item.baifenRate">
                    <th>事业部</th>
                    <th>总业绩占比</th>
                    <th>总订单数占比</th>
                  </tr>
                  <tr class="th_header" v-else>
                    <th>事业部</th>
                    <th>总业绩(元)</th>
                    <th>总订单数(条)</th>
                  </tr>
                  <tr v-for="(item_table,index_table) in item.baseList" :key="index_table">
                    <td>{{item_table.companyName}}</td>
                    <td>
                      <transition name="slide">
                        <span v-if="item.baifenRate">{{item_table.amtRate || 0}}%</span>
                      </transition>
                      <transition name="slide">
                        <span v-if="!item.baifenRate">{{ item_table.payAmt ? item_table.payAmt.toLocaleString() : 0 }}</span>
                      </transition>
                    </td>
                    <td>
                      <transition name="slide">
                        <span v-if="item.baifenRate">{{item_table.numRate || 0}}%</span>
                      </transition>
                      <transition name="slide">
                        <span v-if="!item.baifenRate">{{ item_table.orderNum ? item_table.orderNum.toLocaleString() : 0 }}</span>
                      </transition>
                    </td>
                  </tr>
                </table>
              </transition>
            </div>
            <div class="value_cont">
              <div class="title_label">VIP班业绩</div>
              <el-row v-if="isPc">
                <el-col :span="15">
                  <div class="title gray">总业绩（元）</div>
                  <div class="value">
                    <span class="value_value">{{item.vipAmt}}</span>
                    <span class="value_baifen">({{item.vipAmtRate}}%)</span>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div class="title gray">总订单数（单）</div>
                  <div class="value">
                    <span class="value_value value_value_2">{{item.vipNum}}</span>
                    <span class="value_baifen">({{item.vipNumRate}}%)</span>
                  </div>
                </el-col>
              </el-row>
              <el-row v-else type="flex" class="mobile-value-cont">
                <div class="mobile-value-cont-item">
                  <p class="title gray">总业绩（元 </p>
                  <p class="value">{{item.vipAmt}}</p>
                  <p class="value_baifen">({{item.vipAmtRate}}%)</p>
                </div>
                <div class="mobile-value-cont-item">
                  <p class="title gray">总订单数（单）</p>
                  <p class="value">{{item.vipNum}}</p>
                  <p class="value_baifen">({{item.vipNumRate}}%)</p>
                </div>
              </el-row>
              <div class="line"></div>
              <div class="title module-title">事业部数据</div>
              <transition name="fade">
                <table class="table" border="0" cellspacing="0" v-if="item.show3">
                  <tr class="th_header" v-if="item.baifenRate">
                    <th>事业部</th>
                    <th>总业绩占比</th>
                    <th>总订单数占比</th>
                  </tr>
                  <tr class="th_header" v-else>
                    <th>事业部</th>
                    <th>总业绩(元)</th>
                    <th>总订单数(条)</th>
                  </tr>
                  <tr v-for="(item_table,index_table) in item.vipList" :key="index_table">
                    <td>{{item_table.companyName}}</td>
                    <td>
                      <transition name="slide">
                        <span v-if="item.baifenRate">{{item_table.amtRate || 0}}%</span>
                      </transition>
                      <transition name="slide">
                        <span v-if="!item.baifenRate">{{ item_table.payAmt ? item_table.payAmt.toLocaleString() : 0 }}</span>
                      </transition>
                    </td>
                    <td>
                      <transition name="slide">
                        <span v-if="item.baifenRate">{{item_table.numRate || 0}}%</span>
                      </transition>
                      <transition name="slide">
                        <span v-if="!item.baifenRate">{{ item_table.orderNum ? item_table.orderNum.toLocaleString() : 0 }}</span>
                      </transition>
                    </td>
                  </tr>
                </table>
              </transition>
            </div>
          </div>
        </template>
        <div class="nodata" v-else>暂无数据</div>
      </div>
    </div>
    <!-- 各项目数据end -->
    <BackTop scroll=".projectDataboard" />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getTotalStatistics, getProjectStatistics, getAvailableCompanyList } from "./api"
const  isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)

const topTitleObj = {
  1: '教师资格证',
  2: "教师招聘",
  3: "考试用书",
  4: "普通话",
  5: "自考学历",
  6: "成人高考",
  7: "考研",
  8: "会计师",
  9: "金融类",
  10: "电教馆",
  11: "导游证",
  12: "社会工作者",
  13: "健康管理师",
  14: "营养师",
  15: "其他",
  16: "全媒体运营师",
  20: "CCAA注册审核员",
  22: "演出经纪人"
}
const shiyebuTabs = [
  { name: "收起事业部", id: 1, },
  { name: "显示事业部", id: 2, }
]

const baifenTabs = [
  { name: "显示百分比(%)", id: 1, },
  { name: "显示金额(元)", id: 2, }
]

const dateOption = {
  shortcuts: [
    {
      text: '昨日',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '今日',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近7日',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近14日',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '最近30日',
      onClick (picker) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        picker.$emit('pick', [start, end])
      }
    },
    {
      text: '上个月',
      onClick (picker) {
        const year = new Date().getFullYear()
        const preMon = new Date().getMonth()
        let preLen = new Date(year, preMon, 0).getDate()
        const end = new Date()
        const start = new Date()
        let len = new Date().getDate()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * (preLen - 1) - 3600 * 1000 * 24 * len)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * len)
        picker.$emit('pick', [start, end])
      }
    }
  ]
}

export default {
  name: 'ProjectDataboard',

  computed: {
    isPc() {
      const userAgent = window.navigator.userAgent
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(userAgent)) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      loading: false,
      topTitleObj,
      shiyebuTabs,
      shiyebuIndex: 0,
      baifenTabs,
      baifenIndex: 0,
      defaultDate: null,
      compareDate: null,
      pickerDefaultDate: '',
      pickerCompareDate: '',
      templateCompare: null,
      datePickerOption: {
        ...dateOption,
        onPick: (obj) => {
          this.pickerDefaultDate = new Date(obj.minDate).getTime()
        },
        disabledDate: (time) => {
          if (this.pickerDefaultDate) {
            const i = dayjs(time)
            const t = dayjs(this.pickerDefaultDate)
            const s = t.subtract(3, 'month')
            const e = t.add(3, 'month')
            return !i.isBetween(s, e, 'day', '[')
          }
          return false
        }
      },
      compareDatePickerOption: {
        ...dateOption,
        onPick: (obj) => {
          this.pickerCompareDate = new Date(obj.minDate).getTime()
        },
        disabledDate: (time) => {
          if (this.pickerCompareDate) {
            const i = dayjs(time)
            const t = dayjs(this.pickerCompareDate)
            const s = t.subtract(3, 'month')
            const e = t.add(3, 'month')
            return !i.isBetween(s, e, 'day', '[')
          }
          return false
        }
      },
      companyList: [],
      isSameMonth: true,
      topInfo: {},
      cumulative: {},
      samePeriod: {},
      data: [],
      contHeight: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.contHeight = document.body.offsetHeight - document.getElementById('projectDataboard').offsetTop - 15
    })
    const time = dayjs().format('YYYY-MM-DD')
    const timeCompare = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
    this.defaultDate = [time, time]
    this.compareDate = [timeCompare, timeCompare]
    this.getAvailableCompanyList().then(() => {
      this.init()
    })
  },
  methods: {
    getAvailableCompanyList () {
      return getAvailableCompanyList().then(({ code, data }) => {
        if (code === 0) {
          this.companyList = [
            ...data,
            { name: '中英考研', id: '100' },
            { name: '师来考编', id: '300' },
            { name: '神啦考研', id: '400' }
          ]
        }
        return true
      })
    },
    changeDate (dateTime) {
      this.defaultDate = dateTime
      const [s1, s2] = dateTime
      // 设置默认对比时间
      const cs = dayjs(s1).subtract(1, 'month').format('YYYY-MM-DD')
      const ce = dayjs(s2).subtract(1, 'month').format('YYYY-MM-DD')
      this.compareDate = [cs, ce]
      // 是否同月
      this.isSameMonth = dayjs(s1).isSame(s2, 'month')
      this.init()
    },
    changeCompareDate (dateTime) {
      this.compareDate = dateTime
      this.init()
    },
    init () {
      this.baifenIndex = 0
      this.getData()
    },
    async getData () {
      this.loading = true
      const [ startDate, endDate ] = this.defaultDate
      const [ compareStartDate, compareEndDate ] = this.compareDate
      const params = {
        startDate,
        endDate,
        compareStartDate,
        compareEndDate
      }
      const res = await getTotalStatistics(params)
      let { current, last_month_cumulative, last_month_same_period } = res.data
      if (current) {
        for (const key in current) {
          if (key.indexOf('Rate') > -1) {
            current[key] = current[key]
          }
        }
        this.topInfo = current // 当前数据
      }
      if (last_month_cumulative) {
        for (const key in last_month_cumulative) {
          if (key.indexOf('Rate') > -1) {
            last_month_cumulative['isDown_' + key] = last_month_cumulative[key] < 0
            last_month_cumulative[key] = Math.abs(last_month_cumulative[key])
          }
        }
        this.cumulative = last_month_cumulative // 上月累计
      }
      if (last_month_same_period) {
        for (const key in last_month_same_period) {
          if (key.indexOf('Rate') > -1) {
            last_month_same_period['isDown_' + key] = last_month_same_period[key] < 0
            last_month_same_period[key] = Math.abs(last_month_same_period[key])
          }
        }
        this.samePeriod = last_month_same_period // 同期
      }

      const resdata = await getProjectStatistics(params)
      const { data } = resdata
      const list = data.map(item => {
        item.show1 = true
        item.show2 = true
        item.show3 = true
        item.baifenRate = true
        item.payAmt = item.payAmt ? item.payAmt.toLocaleString() : 0
        item.orderNum = item.orderNum ? item.orderNum.toLocaleString() : 0
        item.baseAmt = item.baseAmt ? item.baseAmt.toLocaleString() : 0
        item.baseNum = item.baseNum ? item.baseNum.toLocaleString() : 0
        item.vipAmt = item.vipAmt ? item.vipAmt.toLocaleString() : 0
        item.vipNum = item.vipNum ? item.vipNum.toLocaleString() : 0
        if (item.contrastInfo) {
          if (item.contrastInfo.last_month_cumulative) { // 累计
            const t1 = item.contrastInfo.last_month_cumulative.orderNum
            const t2 = item.contrastInfo.last_month_cumulative.payAmt
            const t3 = item.contrastInfo.last_month_cumulative.numRate
            const t4 = item.contrastInfo.last_month_cumulative.amtRate
            item.contrastInfo.last_month_cumulative.orderNum = t1 ? t1.toLocaleString() : 0
            item.contrastInfo.last_month_cumulative.payAmt = t2 ? t2.toLocaleString() : 0
            item.contrastInfo.last_month_cumulative.orderIndex = t3 < 0
            item.contrastInfo.last_month_cumulative.amtIndex =  t4 < 0
            item.contrastInfo.last_month_cumulative.numRate = Math.abs(t3) ? Math.abs(t3) : 0
            item.contrastInfo.last_month_cumulative.amtRate =  Math.abs(t4) ? Math.abs(t4) : 0
          }
          if (item.contrastInfo.last_month_same_period) { // 同期
            const t1 = item.contrastInfo.last_month_same_period.orderNum
            const t2 = item.contrastInfo.last_month_same_period.payAmt
            const t3 = item.contrastInfo.last_month_same_period.numRate
            const t4 = item.contrastInfo.last_month_same_period.amtRate
            item.contrastInfo.last_month_same_period.orderNum = t1 ? t1.toLocaleString() : 0
            item.contrastInfo.last_month_same_period.payAmt = t2 ? t2.toLocaleString() : 0
            item.contrastInfo.last_month_same_period.orderIndex = t3 < 0
            item.contrastInfo.last_month_same_period.amtIndex =  t4 < 0
            item.contrastInfo.last_month_same_period.numRate = Math.abs(t3) ? Math.abs(t3) : 0
            item.contrastInfo.last_month_same_period.amtRate =  Math.abs(t4) ? Math.abs(t4) : 0
          }
        }
        item.orderList = item.orderList.map(val => {
          const companyName = this.companyList.find(items => items.id == val.belongCompanyId)
          val.companyName = companyName ? companyName.name : '--'
          return { ...val }
        })
        item.baseList = item.baseList.map(val => {
          const companyName = this.companyList.find(items => items.id == val.belongCompanyId)
          val.companyName = companyName ? companyName.name : '--'
          return { ...val }
        })
        item.vipList = item.vipList.map(val => {
          const companyName = this.companyList.find(items => items.id == val.belongCompanyId)
          val.companyName = companyName ? companyName.name : '--'
          return { ...val }
        })
        return { ...item }
      })
      this.data = list
      setTimeout(() => {
        this.loading = false
      }, 300)
    },
    toggleFn (type, item, index) {
      switch (type) {
        case 1:
          item.show1 = !item.show1
          this.$set(this.data, index, item)
          break;
        case 2:
          item.show2 = !item.show2
          this.$set(this.data, index, item)
          break;
        case 3:
          item.show3 = !item.show3
          this.$set(this.data, index, item)
          break;
        default:
          break;
      }
    },
    shiyebuChange (value) {
      this.shiyebuIndex = value
      this.data.forEach(item => {
        item.show1 = value == 0 ? false : true
        item.show2 = value == 0 ? false : true
        item.show3 = value == 0 ? false : true
      })
    },
    baifenChange (value) {
      this.baifenIndex = value
      this.data.forEach(item => {
        item.baifenRate = value == 0 ? true : false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "DIN-Regular";
  src: local("Lato"),
    url("../../../assets/font/DIN-Regular.otf") format("opentype");
}
@font-face {
  font-family: "DIN-Bold";
  src: local("Lato"),
    url("../../../assets/font/din-bold_.otf") format("opentype");
}

.border_right {
  border-right: 2px solid #cccccc;
}

.line_cont {
  height: 60px;
  display: flex;
  justify-content: center;
  .line {
    width: 1px;
    height: 100px;
    background-color: #cccccc;
  }
}

.projectDataboard {
  padding: 16px 24px;
  overflow-y: auto;
  white-space: nowrap;
  box-sizing: border-box;
  .row_top {
    display: flex;
    align-items: center;
    ::v-deep .el-range-separator {
      width: 26px;
    }
  }
  .filter-item {
    margin-left: 20px;
    .label {
      padding-right: 12px;
    }
  }
  // 移动端样式
  &.mobile {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 6px;
    .row_top {
      flex-wrap: wrap;
      padding-bottom: 20px;
      .filter-item {
        flex: 1;
        height: 54px;
        display: block;
        margin-top: 14px;
        margin-left: 0;
        .label {
          padding-bottom: 4px;
        }
      }
      .mobile-cnotainer {
        max-width: 100%;
        align-items: end;
      }
      .date-picker {
        flex: 1;
        width: auto;
        min-width: 248px;
        background: #FFFFFF;
        border: none;
        border-radius: 8px;
        ::v-deep .el-icon-date {
          &::before {
            display: block;
            width: 24px;
            height: 24px;
            content: '';
            background: url('../../../assets/images/projectDataboard/rili@2x.png') no-repeat center / 16px 16px;
          }
        }
        ::v-deep .el-range-separator {
          width: 26px;
          line-height: 28px;
        }
      }
      .refresh-btn {
        width: 80px;
        height: 32px;
        margin: 0;
        margin-left: 16px;
        font-size: 14px;
        padding: 0;
        background: #2C8CF0;
        border-radius: 4px;
      }
    }
    .total-plane-mobile {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 16px 16px 0;
      background: #FFFFFF url('../../../assets/images/projectDataboard/data_board_top_bg.png') no-repeat top right / 150px 120px;
      border-radius: 8px;
      .plane-title {
        padding-bottom: 4px;
        line-height: 22px;
        font-weight: 600;
        font-size: 16px;
        color: #2F2F2F;
      }
      .jituan_icon {
        width: 24px;
        height: 24px;
      }
      .icon-question {
        width: 24px;
        height: 24px;
      }
    }
    .data-module {
      width: 100%;
      // text-align: center;
      padding-bottom: 26px;
      .data-label {
        padding-top: 24px;
        line-height: 20px;
        font-weight: 600;
        font-size: 14px;
        color: #2F2F2F;
      }
      .data-value {
        padding-top: 8px;
        line-height: 24px;
        font-size: 20px;
        color: #2F2F2F;
        .rate {
          margin-left: 8px;
          font-weight: normal;
          font-family: DIN-Regular, DIN;
          vertical-align: middle;
          line-height: 18px;
          font-size: 14px;
          color: #595959;
        }
      }
      .compare-module {
        width: 100%;
        margin-top: 8px;
        box-sizing: border-box;
        padding: 12px;
        background: #F9F9F9;
        border-radius: 0px 16px 16px 16px;
        .c-name {
          padding-bottom: 12px;
          line-height: 18px;
          font-size: 12px;
          color: #9C9C9C;
        }
        .i-value {
          display: flex;
          justify-content: space-between;
          margin-left: 0;
          &.tips {
            font-size: 12px;
          }
        }
        .i-index {
          flex: unset;
        }
        ::v-deep .el-col {
          & + .el-col {
            padding-left: 12px;
          }
        }
      }
      & + .data-module {
        border-top: 1px solid #F4F4F4;
      }
    }
    .data-detail {
      padding-top: 26px;
      // text-align: left;
      .detail-item  {
        flex: 1;
        width: 0;
        & + .detail-item {
          position: relative;
          &::before {
            display: block;
            content: '';
            width: 1px;
            height: 40px;
            margin-top: -20px;
            border: 1px solid #F4F4F4;
            position: absolute;
            left: 0;
            top: 50%;
          }
        }
      }
      .data-label-sub {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        font-weight: 400;
        line-height: 20px;
        font-size: 14px;
        color: #2F2F2F;
        .rate {
          vertical-align: middle;
          line-height: 18px;
          font-size: 14px;
          color: #2C8CF0;
        }
      }
      .data-value-sub {
        padding-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 18px;
        line-height: 32px;
        color: #2F2F2F;
      }
    }
    .cont_2 {
      padding-top: 32px;
      .top {
        padding: 0 0 20px;
        justify-content: space-between;
        .project_icon {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
        .title {
          line-height: 22px;
          font-size: 16px;
          color: #2F2F2F;
        }
        .tabs_value {
          margin: 0;
          .items_item {
            padding: 8px;
            transition: all 0.16s ease-in;
            &.active {
              box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1300);
              font-weight: 600;
              font-size: 12px;
            }
          }
        }
      }
      .list {
        margin: 0;
        .item {
          width: 100%;
          margin: 0 0 16px;
        }
        .title_span {
          width: 110px;
          height: 32px;
          border-radius: 0px 100px 100px 0px;
        }
        .value_cont {
          padding: 24px 16px 0;
          margin-top: 0;
          .title_label {
            height: 20px;
            font-weight: 600;
            line-height: 20px;
            font-size: 14px;
            color: #2C8CF0;
            &::before {
              width: 4px;
              height: 12px;
              background: #2C8CF0;
              border-radius: 2px;
              top: 4px;
              bottom: initial;
            }
          }
          &.head_cont {
            ::v-deep .el-row {
              display: flex;
              .el-col {
                width: 0;
                &:first-child {
                  flex: 1;
                }
                & + .el-col {
                  min-width: 120px;
                }
              }
            }
            .title {
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
            }
            .table {
              padding-top: 24px;
              border-bottom: 1px solid #F4F4F4;
            }
          }
        }
        .table {
          padding: 16px 0 24px;
          margin: 0;
          td {
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 16px;
            font-weight: 400;
            font-size: 12px;
            color: #2F2F2F;
          }
        }
        .th_header {
          height: 36px;
          background: #F4F4F4;
          border-radius: 8px;
          th {
            font-weight: 400;
            line-height: 36px;
            font-size: 12px;
            color: #8B8B8B;
          }
        }
        .no-mobile {
          display: none !important;
        }
      }
    }
    .mobile-value-cont {
      .mobile-value-cont-item {
        &:first-child {
          flex: 1;
        }
        & + .mobile-value-cont-item {
          min-width: 120px;
        }
      }
      .value_baifen {
        padding-top: 4px;
        vertical-align: initial;
      }
      .value {
        margin-top: 4px !important;
      }
    }
    .num {
      font-family: DIN-Bold, DIN;
      font-weight: bold;
    }
    .rate {
      font-family: DIN-Regular, DIN;
    }
    .blue {
      color: #2C8CF0 !important;
    }
  }
  &:not(.mobile) {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #9dc3f2;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
  }
}
button {
  margin: 0 12px;
}
.blue {
  color: #2c8cf0 !important;
}
.gray {
  color: #8b8b8b !important;
}
.row {
  max-width: 1600px;
  border-radius: 8px;
}
.title {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2f2f2f;
  line-height: 30px;
}
.jituan_icon,
.project_icon,
.icon-question {
  width: 28px;
  height: 28px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
.jituan_icon {
  background: url("../../../assets/images/projectDataboard/jituan_icon.png")
    no-repeat;
  background-size: 100% 100%;
}
.project_icon {
  background: url("../../../assets/images/projectDataboard/project_icon.png")
    no-repeat;
  background-size: 100% 100%;
}
.icon-question {
  background: url('../../../assets/images/yeji-2@2x.png') no-repeat center / contain;
  cursor: pointer;
}

.title_h {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #2f2f2f;
  line-height: 20px;
  margin-bottom: 8px;
  &.blue {
    font-weight: 600;
  }
}
.value {
  font-size: 26px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; // 默认不换行；
  line-height: 32px;
  display: block;
  color: #2F2F2F;
  .rate {
    font-size: 20px;
    font-family: DIN-Regular, DIN;
    font-weight: 400;
    color: #595959;
    line-height: 32px;
  }
}
.title_sub {
  line-height: 18px;
  font-size: 12px;
  color: #2F2F2F;
  .icon-question {
    width: 18px;
    height: 18px;
    margin-top: -4px;
    background-size: 20px;
  }
}
.value_sub {
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  padding-right: 30%;
  font-family: DIN-Bold, DIN;
  line-height: 18px;
  font-weight: bold;
  font-size: 14px;
  color: #2F2F2F;
  .index {
    margin-left: 12px;
    padding-left: 16px;
    font-family: DIN-Regular, DIN;
    font-weight: 400;
    line-height: 18px;
    position: relative;
    &::before {
      display: block;
      content: '';
      width: 16px;
      height: 18px;
      position: absolute;
      top: 0;
      left: 0;
      background-repeat: no-repeat;
      background-size: 10px 12px;
      background-position: center left;
    }
    &.up {
      color: #ED7144;
      &::before {
        background-image: url('../../../assets/images/icon_index_up.png');
      }
    }
    &.down {
      color: #7DE49F;
      &::before {
        background-image: url('../../../assets/images/icon_index_down@2x.png');
      }
    }
  }
  &.tips {
    font-weight: 400;
    color: #757575;
  }
}
.value_value {
  font-size: 18px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; // 默认不换行；
  line-height: 32px;
  display: inline-block;
  vertical-align: middle;
  height: fit-content;
  line-height: inherit;
  flex: 2;
}
.cont_1 {
  margin: 24px 0;
  padding: 24px 32px 24px;
  box-sizing: border-box;
  background: #ffffff
    url("../../../assets/images/projectDataboard/data_board_top_bg.png")
    no-repeat right top;
  background-size: 174px 162px;
}
.cont_data {
  margin: 24px 0 0 0;
  .bg-row {
    padding: 16px;
    margin: 16px -16px 0;
    background: #F9F9F9;
    border-radius: 8px;
  }
  ::v-deep .el-col {
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
}
.cont_2 {
  .top {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 24px;
    .tabs_value {
      margin: 0 40px;
      .items {
        display: inline-flex;
        align-items: center;
        background: #e8e8e8;
        border-radius: 4px;
        .items_item {
          padding: 8px 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 17px;
          color: #9c9c9c;
          border-radius: 4px;
          cursor: pointer;
          &.active {
            color: #2f2f2f;
            background-color: #ffffff;
          }
        }
      }
    }
  }
}

.list {
  margin: 24px -14px;
  white-space: pre-wrap;
  .item {
    display: inline-block;
    width: 300px;
    margin: 0 12px 24px;
    padding: 24px 0 24px 0;
    background: #ffffff;
    border-radius: 8px;
    vertical-align: top;
    &:last-child {
      margin-right: 0;
    }
    .title_span {
      display: inline-block;
      min-width: 110px;
      max-width: 200px;
      padding: 0 12px;
      height: 24px;
      background: #2c8cf0;
      border-radius: 0px 100px 100px 0px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 24px;
      text-align: center;
    }
    .value_cont {
      padding: 0 24px;
      margin: 24px 0 0 0;
      .title {
        white-space: nowrap;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #2f2f2f;
        line-height: 17px;
      }
      .value {
        font-size: 18px;
        font-family: DIN-Bold, DIN;
        font-weight: bold;
        line-height: 22px;
        position: relative;
        display: flex;
      }
      .line {
        margin: 24px 0 15px 0;
        height: 1px;
        border: 1px solid #f4f4f4;
      }
      .table {
        width: 100%;
        margin: 15px 0;
        .th_header {
          height: 32px;
          background: #f4f4f4;
          border-radius: 4px;
          th {
            text-align: center;
            color: #8B8B8B;
          }
        }
        tr td {
          padding: 8px;
          text-align: center;
          position: relative;
          overflow: hidden;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #2f2f2f;
        }
      }

      ::v-deep .el-col {
        padding: 0 10px 0 0;
        box-sizing: border-box;
        &:last-child {
          padding: 0;
        }
      }
    }
  }
  .cont-sup-info {
    padding-top: 24px;
    .i-name {
      min-width: 88px;
      line-height: 18px;
      font-size: 12px;
      color: #757575;
    }
    & + .cont-sup-info {
      padding-top: 24px;
    }
  }
}
.i-value {
  margin-left: 4px;
  font-family: DIN-Regular, DIN;
  line-height: 18px;
  font-weight: 400;
  font-size: 14px;
  color: #2F2F2F;
  &.tips {
    font-weight: 400;
    color: #757575;
  }
}
.i-index {
  flex: 1;
  padding-left: 12px;
  font-family: DIN-Regular, DIN;
  font-weight: 400;
  line-height: 18px;
  position: relative;
  &::before {
    display: block;
    content: '';
    width: 16px;
    height: 18px;
    position: absolute;
    left: 0;
    top: 0;
    background-repeat: no-repeat;
    background-size: 10px 12px;
    background-position: center left;
  }
  &.up {
    color: #ED7144;
    &::before {
      background-image: url('../../../assets/images/icon_index_up.png');
    }
  }
  &.down {
    color: #7DE49F;
    &::before {
      background-image: url('../../../assets/images/icon_index_down@2x.png');
    }
  }
}
.title_label {
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #2c8cf0;
  line-height: 17px;
  padding-left: 10px;
  margin-bottom: 16px;
  position: relative;
  &::before {
    content: "";
    width: 4px;
    height: 11px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #2c8cf0;
  }
}
.change_down {
  height: 32px;
  background: #f4f4f4;
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b3b3b3;
  line-height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  // cursor: pointer;
  margin: 16px 0;
  .down {
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    background: url("../../../assets/images/projectDataboard/down_icon.png")
      no-repeat;
    background-size: 100% 100%;
    transition: all 0.3s;
    &.up {
      transform: rotate(180deg);
    }
  }
}
.value_baifen {
  font-size: 14px;
  font-family: DIN-Regular, DIN;
  font-weight: 400;
  color: #595959;
  display: inline-block;
  vertical-align: middle;
  margin-left: 4px;
  position: relative;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  flex: 1;
}

.nodata {
  width: 200px;
  margin: 100px auto 0;
  text-align: center;
  font-size: 18px;
  color: #777777;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s;
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  margin: auto;
}
.slide-enter,
.slide-leave-to {
  // opacity: 0;linear
  right: -300px;
}
.th_header {
  position: relative;
}
</style>
